module.exports = __webpack_public_path__ + "static/WhiteBackgroundSketch-fcd10e5a0d7da3e8391a340f8dca4ec2.png";